import { render, staticRenderFns } from "./Anschrift.vue?vue&type=template&id=44d88e90&"
import script from "./Anschrift.vue?vue&type=script&lang=js&"
export * from "./Anschrift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports